var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('installment-price',{class:[
        (_vm.product_modal || _vm.product_page || _vm.related || _vm.page_wish_list) ? 'text-left' : 'text-center'
    ]},[_vm._v("\n    "+_vm._s(_vm.interestFreeInstallments())+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }